import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100%;
  overflow: hidden;
  position: relative;
`;



// WEBPACK FOOTER //
// ./src/components/Slider/elements.js